module.exports = __webpack_public_path__ + "fonts/RenaultLife-BoldItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-BoldItalic.eot
// module id = 351
// module chunks = 0